/* src/app/components/payroll/authorizations/authorization-details/authorization-details.component.css */
.ppl-mb24 {
  margin-bottom: 24px !important;
}
th {
  background-color: #a8e4e14d !important;
}
.row-toggle-icon {
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  color: #1976d2;
}
.row-toggle-icon:hover {
  background: #e3f2fd;
}
/*# sourceMappingURL=authorization-details.component-34NNX5JY.css.map */
